import { artType, nextGenFlyoutPanelEnum, nextGenSidebarTabKeyEnum, nextgenScreenMode } from '../constants';
import { changeNextgenUiStatus, changeUploadingFileStatus } from '../actions';
import {
  checkFileBeforeUpload,
  doActionsBeforeUpload,
  hideCover,
  uploadFile,
} from '../../uploadimage/components/UploadButton/logics';
import { getCanvasOverVignetteConfig, getCurrentLogoEditingStatus, getSidebarTabKey } from '../../main/selectors';
import {
  hideTransparencyCover,
  hideWaitingCover,
  setBeforeUnloadListen,
  showTransparencyCover,
  showWaitingCover,
  updateWaitingCover,
} from '../../main/actions';
import { useDispatch, useSelector } from 'react-redux';

import { GoogleTagManager } from '../../utils/aop';
import { getIsNextGenUI } from '../selectors';
import { getNextgenUiStatus } from '../sidebar/LeftFlyout/selectors';
import { getScreenMode } from '../logics';
import { getStoreData } from '../../uploadimage/selectors';
import { getUploadMultipleCount } from '../Upload/selectors';
import { isMobileOnly } from 'react-device-detect';
import { sidebarTabKeyEnum } from '../../utils/constants';
import { useEffect } from 'react';

export default function useUploadMultiple() {
  const dispatch = useDispatch();
  const textIcon = '/resources/assets/ui/desktop/warning.png';
  const nextgenUiStatus = useSelector(getNextgenUiStatus);
  const uploadMultipleStatus = nextgenUiStatus.uploadMultiple;
  const uploadMultipleCount = useSelector(getUploadMultipleCount);
  const files = (uploadMultipleStatus && uploadMultipleStatus.files) || [];
  const uploadProps = (uploadMultipleStatus && uploadMultipleStatus.props) || {};
  const storeData = useSelector(getStoreData);

  const currentStatus = useSelector(getCurrentLogoEditingStatus);
  const canvasOverVignetteConfig = useSelector(getCanvasOverVignetteConfig);
  const isNextgenUi = useSelector(getIsNextGenUI);
  const currentSidebarTabkey = useSelector(getSidebarTabKey);

  let upload = (file, props) => {
    let isBackground = props.isBackground;
    if (isBackground === undefined) {
      isBackground =
        currentSidebarTabkey === nextGenSidebarTabKeyEnum.Background ||
        currentSidebarTabkey === sidebarTabKeyEnum.Background;
    }

    const uploadFileParams = {
      ...storeData,
      dispatch,
      file,
      isBackground,
      lowDpiLogoGuid: storeData.logoEditingStatus.lowDpiData?.lowDpiLogoGuid,
      canvasOverVignetteConfig,
      isNextgenUi,
      directToCanvas: !props.allowMultiple || files.length === 1,
    };

    if (checkFileBeforeUpload(dispatch, file)) {
      doActionsBeforeUpload({
        dispatch,
        currentStatus,
        canvasKey: storeData.canvasKey,
        selectedLogo: storeData.selectedLogo,
        isBackground,
        digitalUploadNew: props.digitalUploadNew,
      });

      if (isBackground) {
        dispatch(showWaitingCover({ showProgress: true }));
        const text = 'Loading Image';
        dispatch(
          updateWaitingCover({
            text,
            textStyle:
              isMobileOnly && text !== 'Loading Image'
                ? 'waitingcover-text-sharpen-mobile'
                : 'waitingcover-text-sharpen',
            textIcon: text === 'Loading Image' ? null : textIcon,
          })
        );
      } else {
        dispatch(showTransparencyCover());
        if (files.length > 1) dispatch(changeNextgenUiStatus({ showUploadCover: true }));
        else {
          dispatch(changeNextgenUiStatus({ showCanvasCover: true }));
          if (getScreenMode() === nextgenScreenMode.small)
            dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.None } }));
          else dispatch(changeNextgenUiStatus({ showUploadCover: true }));
        }
      }

      delete uploadFileParams.image; //clear image property before new uploading
      //clear artGuidToBeReplaced oncce not replaceting
      if (!uploadMultipleStatus.props.replace) dispatch(changeNextgenUiStatus({ artGuidToBeReplaced: null }));

      uploadFile(uploadFileParams);
    }
  };

  upload = GoogleTagManager(upload, 'studio_uploadlogo');

  useEffect(() => {
    if (!uploadMultipleStatus) return;
    if (!uploadMultipleStatus.files) return;

    const fileToUpload = uploadMultipleStatus.files.find((file) => !file.complete);
    if (fileToUpload) {
      if (files.length > 1) dispatch(setBeforeUnloadListen(false));
      if (fileToUpload.complete === undefined) {
        dispatch(changeUploadingFileStatus({ file: fileToUpload, complete: false }));
        upload(fileToUpload, uploadProps);
        return;
      }
    } else {
      if (files.length > 1) {
        dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.UploadPanel } }));
        hideCover(dispatch);
      }
      dispatch(changeNextgenUiStatus({ uploadMultiple: null }));
      dispatch(setBeforeUnloadListen(true));
      dispatch(changeNextgenUiStatus({ selectedArtType: artType.Recent }));
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadMultipleStatus, uploadMultipleCount]);

  return { upload };
}
